import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const DEFAULTS = {
  practiceMode: "live",
  reopeningWindow: { en: "Spring 2027", fr: "printemps 2027" },
  loading: true,
};

const ConfigContext = createContext(DEFAULTS);

export const ConfigProvider = ({ children }) => {
  const [state, setState] = useState(DEFAULTS);
  useEffect(() => {
    api.get("/config")
      .then((r) => setState({
        practiceMode: r.data.practice_mode || "live",
        reopeningWindow: r.data.reopening_window || DEFAULTS.reopeningWindow,
        loading: false,
      }))
      .catch(() => setState({ ...DEFAULTS, loading: false }));
  }, []);
  return <ConfigContext.Provider value={state}>{children}</ConfigContext.Provider>;
};

export const useConfig = () => useContext(ConfigContext);
export const useIsWaitlist = () => useConfig().practiceMode === "waitlist";
export const useReopeningWindow = () => {
  const { reopeningWindow } = useConfig();
  return reopeningWindow || DEFAULTS.reopeningWindow;
};
